import { StandardAPIRequest } from 'app/types/api'
import {
  CompanyData,
  CompanyProfile,
  Organization,
} from 'app/types/organization'
import { clientGetIdToken } from 'app/utils/cognito'
import { SETTINGS } from 'app/utils/settings'

export const getPublicCompanyProfileFromOrganization = async (
  organization: string | string[] | undefined
): Promise<CompanyProfile | null> => {
  var headers: HeadersInit = {}
  try {
    const profileRes = await fetch(
      `${SETTINGS.API_URL}/organization/profile/${organization}`,
      {
        headers,
        method: 'GET',
      }
    )
    const events: StandardAPIRequest<CompanyProfile> = await profileRes.json()
    if (events.error) {
      throw Error(events.error.message)
    }
    if (events.data === null) {
      return null
    }
    return events.data
  } catch (error) {
    console.log(error)
    return null
  }
}

export const getOrganization = async (
  organization: string | string[] | undefined
): Promise<Organization | null> => {
  var headers: HeadersInit = {}
  try {
    const profileRes = await fetch(
      `${SETTINGS.API_URL}/organization/${organization}`,
      {
        headers,
        method: 'GET',
      }
    )
    const events: StandardAPIRequest<Organization> = await profileRes.json()
    if (events.error) {
      throw Error(events.error.message)
    }
    if (events.data === null) {
      return null
    }
    return events.data
  } catch (error) {
    console.log(error)
    return null
  }
}

export const getPublicCompanyDataFromOrganization = async (
  organization: string | string[] | undefined
): Promise<CompanyData[] | null> => {
  var headers: HeadersInit = {}
  try {
    const companyRes = await fetch(
      `${SETTINGS.API_URL}/organization/company_data/public/${organization}`,
      {
        headers,
        method: 'GET',
      }
    )
    const events: StandardAPIRequest<CompanyData[]> = await companyRes.json()
    if (events.error) {
      throw Error(events.error.message)
    }
    if (events.data === null) {
      return null
    }
    return events.data
  } catch (error) {
    console.log(error)
    return null
  }
}

export const getCompanyProfile = async (): Promise<CompanyProfile | null> => {
  const idToken = await clientGetIdToken()
  let headers: HeadersInit = {
    'Content-Type': 'application/json',
  }
  if (idToken) {
    headers.Authorization = `Bearer ${idToken}`
  }
  try {
    const profileRes = await fetch(`${SETTINGS.API_URL}/organization`, {
      method: 'GET',
      headers,
    })
    const events: StandardAPIRequest<CompanyProfile> = await profileRes.json()
    if (events.error) {
      throw Error(events.error.message)
    }
    if (events.data === null) {
      return null
    }
    return events.data
  } catch (error) {
    console.log(error)
    return null
  }
}
